import { Link } from 'react-router-dom';
import Logo from '@/components/branding/Logo';

const FOOTER_LINKS = [
  { to: '/privacy', label: 'Privacy', external: false },
  { to: '/terms', label: 'Terms', external: false },
  { to: 'mailto:support@citizenly.net', label: 'Contact', external: true },
];

export default function LandingFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="bg-cream border-t border-border/60">
      <div className="mx-auto w-full max-w-7xl px-6 md:px-8 lg:px-12 py-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div>
          <Logo size="sm" />
          <p className="font-sans text-xs text-text-muted mt-1.5">
            USCIS interview prep, graded the way they grade.
          </p>
          <p className="font-sans text-xs text-text-muted mt-3">
            © {year} Citizenly. Not affiliated with USCIS.
          </p>
        </div>

        <nav className="flex items-center gap-6">
          {FOOTER_LINKS.map((link) =>
            link.external ? (
              <a
                key={link.label}
                href={link.to}
                className="font-sans text-sm text-text-secondary hover:text-text-primary transition-colors"
              >
                {link.label}
              </a>
            ) : (
              <Link
                key={link.label}
                to={link.to}
                className="font-sans text-sm text-text-secondary hover:text-text-primary transition-colors"
              >
                {link.label}
              </Link>
            )
          )}
        </nav>
      </div>
    </footer>
  );
}
